import { ChartDataset, ChartType } from "chart.js";

import { getColor } from "@/utils";

export const colorizeDataset = <T = ChartDataset<ChartType, number[]>>(
  dataset: T,
  index: number,
  transparent: boolean
) => {
  const color = getColor(index, { transparent });

  return {
    backgroundColor: color,
    borderColor: color,
    hoverBorderColor: color,
    pointBackgroundColor: color,
    hoverBackgroundColor: color,
    pointBorderColor: color,
    pointHoverBackgroundColor: color,
    ...dataset,
  };
};
